import React from "react";
import dynamic from "next/dynamic";
import Device from "../../constants/Device";
import Image from "../PostImage/PostImage";
import ShareGiveaway from "../ShareGiveaway/ShareGiveaway";
import { RenderArticleSchema } from "../../helpers/Helper";
import { useAppContext } from "@components/Provider";
const PageBuilder = dynamic(() => import("../../helpers/PageBuilder"));

import styles from "./Page.module.css";
import "./Page.css";

const Page = (props) => {
  const { post } = props.data[0].Post;
  const { siteId, data, isMobile, updatePageViews, isTablet, host } = useAppContext();
  const { SiteSettings } = data || {};

  const checkIfHasShareLink = (post) => {
    if (post.components && post.components.length > 0) {
      shareLink = post.components.filter(
        (cmp) => cmp && cmp?.type === "share-giveaway-button-link"
      );
      if (shareLink.length > 0) return true;
      return false;
    }
    return false;
  };
  //Checks if post has any share giveaway link
  let shareLink;
  const hasShareLink = checkIfHasShareLink(post);

  updatePageViews();

  const pageBuilderOptions = {
    Newsletter_Settings: {
      ...SiteSettings.newsletter_settings,
    },
    postType: post.post_type,
  };

  const conditionalNOBG =
    post.featured_media && (post.featured_media.Name || post.featured_media.name);
  const conditionalHero = () => {
    if (conditionalNOBG) return [styles["PostPage-hero"], "PostPage-hero"].join(" ");
    else return styles["PostPage-hero-noBG"];
  };

  const renderPage = () => {
    return (
      <div
        className={[styles["PostPage"], isMobile ? "topPadding" : ""].join(" ")}
        style={{
          // "--PostPage-margin-top": conditionalNOBG ? "2.65rem" : 0,
          "--PostPage-hero-height": hasShareLink ? "auto" : "50vh",
          "--PostPage-hero-img-1024-height": hasShareLink ? "50vh" : "30vh",
          "--PostPage-hero-img-1024-l-height": hasShareLink ? "120vh" : "50vh",
          "--PostPage-hero-img-767-height": hasShareLink ? "60vh" : "50vh",
          "--PostPage-hero-img-575-height": hasShareLink ? "70vh" : "30vh",
        }}
      >
        <React.Fragment>
          <div
            style={{ minHeight: hasShareLink ? "460px" : "170px" }}
            className={conditionalHero()}
          >
            <div className={styles["PostPage-hero-text"]}>
              <h1
                style={{
                  color: `${conditionalNOBG ? "white" : "black"}`,
                  fontStyle: "normal",
                }}
                dangerouslySetInnerHTML={{ __html: post.title }}
              />
              <h2
                style={{ color: "white", fontStyle: "normal" }}
                dangerouslySetInnerHTML={{ __html: post.sub_title }}
              />
              {hasShareLink ? <ShareGiveaway link={shareLink} /> : null}
            </div>
            <div className={[styles["overlay"], "overlay"].join(" ")}></div>
            {conditionalNOBG ? (
              <Image
                {...post.featured_media}
                size={isMobile ? Device.PHONE : Device.DESKTOP}
                height={hasShareLink ? 80 : 40}
                width={100}
                isLazyload={false}
                className={"Page-Hero-Image"}
              />
            ) : null}
          </div>
          <div className={[styles["PostPage-content"], "PostPage-content"].join(" ")}>
            <PageBuilder
              post={post}
              siteId={siteId}
              pageBuilderOptions={pageBuilderOptions}
              isMobile={isMobile}
              isTablet={isTablet}
              classes={[styles["Embed"]]}
            />
          </div>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={RenderArticleSchema(post, SiteSettings, host)}
          />
        </React.Fragment>
      </div>
    );
  };

  return <React.Fragment>{renderPage()}</React.Fragment>;
};

export default Page;
